import { Controller } from '@hotwired/stimulus'
import { loadTurboFrame } from 'helpers/turbo_frames'

export default class extends Controller {
  static targets = []
  static values = {
    search: Boolean
  }

  connect() {
    if (!this.searchValue) return

    // Carry the page's own ransack params into every fetch this frame makes, so paging and
    // sorting keep the active search. `event.detail.url` is Turbo's documented hook for this.
    this.element.addEventListener('turbo:before-fetch-request', event => {
      new URL(window.location).searchParams.forEach((value, key) => {
        if (key[0] === 'q') {
          event.detail.url.searchParams.append(key, value)
        }
      })
    })

    // A ransack search drives the frame's src rather than submitting: the frame keeps its other
    // params (frame_id, tab, page) and the address bar stays shareable. Cancelling in the form's
    // own `submit` listener is what Turbo checks for (`defaultPrevented`) before it takes over —
    // reaching into `event.detail.formSubmission` from turbo:submit-start would use its internals.
    this.element.addEventListener('submit', this.searchSubmitted)
  }

  disconnect() {
    this.element.removeEventListener('submit', this.searchSubmitted)
  }

  searchSubmitted = event => {
    const form = event.target
    if (!form.id?.includes('search')) return

    event.preventDefault()

    const src = new URL(this.element.getAttribute('src'), window.location.origin)
    const location = new URL(window.location.href)

    deleteRansackParams(src.searchParams)
    deleteRansackParams(location.searchParams)

    // formSubmission.body did not always hold the right entries, so read the form directly.
    new FormData(form).forEach((value, key) => {
      if (key[0] === 'q' && value) {
        src.searchParams.append(key, value)
        location.searchParams.append(key, value)
      }
    })

    // Location MUST be updated first
    history.replaceState(history.state, '', location.href)
    loadTurboFrame(this.element, src)
  }
}

function deleteRansackParams(params) {
  Array.from(params.keys())
    .filter(key => key[0] === 'q')
    .forEach(key => params.delete(key))
}
